import { Fragment, memo } from 'react';
import { API_PATH } from '@zmedia/bm-soccer-ui/service/ContentService';
import { ContentMoreSection } from '@zmedia/bm-soccer-ui/modules/content';
import styles from './style.module.scss';

export function ContentSection(props: any) {
    const { home, away, items = [] } = props;
    const options = {
        url: API_PATH.GET_LIST,
        params: {
            query: `"${home?.team?.name}" OR "${away?.team?.name}"`,
            listType: 'byQuery',
            page: items.length > 0 ? 2 : 1,
        },
    };

    return (
        <ContentMoreSection
            {...props}
            className={styles['content-match-section']}
            title="Tin Tức"
            options={options}
            ComponentEmpty={Fragment}
            name="match-news"
        ></ContentMoreSection>
    );
}

export default memo(ContentSection);
